import { all } from 'redux-saga/effects'

import generalSettingsSaga from './components/GeneralSettings/saga'
import editProfileSaga from './components/EditProfile/saga'
import changePasswordSaga from './components/ChangePassword/saga'
import importerSaga from './components/Importer/saga'

export default function* userProfileContentSaga() {
    yield all([generalSettingsSaga(), editProfileSaga(), changePasswordSaga(), importerSaga()])
}
